const privacySections = [
  {
    title: '1. Information we collect',
    body: [
      'We collect information you provide directly, including account details, profile information, seller listing content, buyer order details, project briefs, messages, uploaded files, support requests, and any other information you submit through AgenticHire.',
      'We may collect payment and payout-related information through our payment providers, such as transaction identifiers, checkout status, connected account status, billing details, refund status, dispute information, and payout eligibility. We do not intentionally store full payment card numbers on AgenticHire servers.',
      'We may automatically collect technical and usage information, including device information, browser type, IP address, pages viewed, referring URLs, timestamps, feature usage, log data, error data, and approximate location derived from network information.',
    ],
  },
  {
    title: '2. How we use information',
    body: [
      'We use information to operate AgenticHire, create and manage accounts, publish and display listings, process orders, facilitate buyer-seller communication, support payments and payouts, provide customer support, and maintain platform security.',
      'We also use information to prevent fraud and abuse, enforce our terms, troubleshoot issues, improve product features, understand marketplace activity, comply with legal obligations, and communicate with users about account, order, security, and platform updates.',
    ],
  },
  {
    title: '3. Marketplace visibility',
    body: [
      'Seller profiles, public listing details, ratings, reviews, pricing, delivery information, and other marketplace content may be visible to other users and visitors.',
      'Buyer project details, private messages, order files, and payment information are not intended to be public, but may be visible to the relevant seller, buyer, AgenticHire personnel or service providers who need access, and payment or compliance partners where required.',
    ],
  },
  {
    title: '4. Buyer materials and seller access',
    body: [
      'When a buyer places an order or contacts a seller, the buyer may provide project briefs, files, credentials, links, data, or other materials. These materials may be shared with the seller so the seller can evaluate, deliver, support, or revise the service.',
      'Sellers are independent users of the platform and are responsible for handling buyer materials lawfully and consistently with their listing, order commitments, and applicable privacy or confidentiality obligations.',
    ],
  },
  {
    title: '5. AI services and third-party tools',
    body: [
      'Listings on AgenticHire may involve AI models, APIs, automation tools, storage providers, analytics providers, communication services, and other third-party tools. Information submitted by users may be processed by those third-party tools when necessary to provide a listed service or operate the platform.',
      'Third-party services process information according to their own terms and privacy policies. Users should review seller listings and avoid sharing information that should not be processed by a seller’s tools or integrations.',
    ],
  },
  {
    title: '6. How we share information',
    body: [
      'We may share information with sellers and buyers involved in the same inquiry or order, payment processors, hosting and database providers, authentication providers, analytics and security providers, customer support tools, legal and compliance advisors, and other vendors that help us operate AgenticHire.',
      'We may disclose information if required by law, subpoena, court order, legal process, payment network rules, fraud investigation, safety concern, rights enforcement, business transfer, or to protect AgenticHire, users, or the public.',
      'We do not sell personal information in the traditional sense. If future privacy laws treat certain analytics or advertising activities as a sale or share, we will provide any required choices.',
    ],
  },
  {
    title: '7. Cookies and similar technologies',
    body: [
      'AgenticHire may use cookies, local storage, pixels, SDKs, and similar technologies to keep users signed in, remember preferences, save drafts, secure sessions, understand usage, improve performance, and measure product activity.',
      'You can control cookies through your browser settings. Blocking some technologies may affect account login, checkout, draft saving, or other platform features.',
    ],
  },
  {
    title: '8. Data retention',
    body: [
      'We keep information for as long as needed to provide AgenticHire, maintain business records, comply with legal and tax obligations, resolve disputes, prevent fraud, enforce agreements, and support legitimate platform operations.',
      'Some information may remain in backups, logs, payment records, dispute records, security systems, or legal archives for a limited period after account deletion or order completion.',
    ],
  },
  {
    title: '9. Security',
    body: [
      'We use reasonable administrative, technical, and organizational safeguards designed to protect information. No system is completely secure, and we cannot guarantee that information will never be accessed, disclosed, altered, or destroyed.',
      'Users are responsible for using strong credentials, protecting account access, limiting unnecessary data sharing, and promptly notifying us of suspected unauthorized account activity.',
    ],
  },
  {
    title: '10. Your choices and rights',
    body: [
      'Depending on where you live, you may have rights to access, correct, delete, export, restrict, or object to certain processing of your personal information. You may also have rights to appeal a decision or lodge a complaint with a privacy regulator.',
      'You can update some account and profile information directly in AgenticHire. For other requests, contact us through the contact channel made available on the platform. We may need to verify your identity before fulfilling a request.',
    ],
  },
  {
    title: '11. Children',
    body: [
      'AgenticHire is not intended for children under 13, and we do not knowingly collect personal information from children under 13. If you believe a child has provided personal information to AgenticHire, contact us so we can review and delete it where appropriate.',
    ],
  },
  {
    title: '12. International users',
    body: [
      'AgenticHire may process and store information in the United States and other countries where we or our service providers operate. These locations may have data protection laws different from those in your jurisdiction.',
    ],
  },
  {
    title: '13. Changes to this policy',
    body: [
      'We may update this Privacy Policy from time to time. If changes are material, we will take reasonable steps to notify users. Continued use of AgenticHire after an updated policy becomes effective means the updated policy applies.',
    ],
  },
  {
    title: '14. Contact',
    body: [
      'Questions or privacy requests can be sent to AgenticHire through the contact channel made available on the platform.',
    ],
  },
];

export function PrivacyPage() {
  return (
    <section className="page-shell legal-page">
      <div className="detail-panel legal-document">
        <span className="eyebrow">Privacy</span>
        <h1>AgenticHire Privacy Policy</h1>
        <p className="legal-updated">Effective date: April 27, 2026</p>
        <p>
          This Privacy Policy explains how AgenticHire collects, uses, shares, and protects information when you use
          our marketplace. It is a general policy template and should be reviewed by counsel before production use.
        </p>

        {privacySections.map((section) => (
          <section key={section.title} className="legal-section">
            <h2>{section.title}</h2>
            {section.body.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </section>
        ))}
      </div>
    </section>
  );
}
